<tooltip-content #barTooltipDisable>        
        <span>Está barra não exibe nenhum dado pois o Polen não está ativo nesta página. Para exibir, fale conosco!</span>        
</tooltip-content>

<tooltip-content #barTooltip>        
        <span>Esta barra mostra o número de visitas que chegaram até este ponto do funil. </span>
        <br>
        <span>Em laranja, as visitas que não interagiram com o Polen e em roxo, os que interagiram com o Polen.</span>
</tooltip-content>

<tooltip-content #barTooltipAllSite>        
        <span>Como o Polen não aparece nesta tela, exibimos aqui o total de tráfego captado nesta parte do funil. </span>        
</tooltip-content>

<div class="slot-bar" *ngIf="bar.active == false">
    <div class="card default-bar disable" [tooltip]="barTooltipDisable" [style.height.px]="bar.height">
    </div>
</div>

<div class="slot-bar" *ngIf="bar.active && type != 'allsite'">
    <div class="card default-bar" [tooltip]="barTooltip" [style.height.px]="bar.height">
        <div *ngFor="let section of bar.sections"  [ngClass]="{'card': true,'section-polen': section.type == 0,'section-original': section.type == 1}"
            class="card section-bar section-polen" [style.height.px]="section.height" >
            <h4 class="card-title">{{section.value | number}}</h4>
        </div>
    </div>
</div>

<div class="slot-bar" *ngIf="bar != null && bar.active && type == 'allsite'">
    <div class="card default-bar section-original card section-bar" [tooltip]="barTooltipAllSite" [style.height.px]="bar.height">
            <h4 class="card-title">{{ totalSection | number}}</h4>       
    </div>
</div>

<!-- <div class="slot-bar" *ngIf="bar != null && bar.active && type == 'allsite'">
    <div class="card default-bar" [tooltip]="barTooltipAllSite" [style.height.px]="bar.height">
        <div class="section-original card section-bar " style="height:445px" >
            <h4 class="card-title">{{ totalSection | number}}</h4>
        </div>
    </div>
</div> -->
